export default __webpack_public_path__ + "static/hero-bg-overlay-91eb1d082b237f840fb62e81680bdc35.png";